import './index.less';

import withPageContainer from '../shared/page-container/with-page-container';
import withIntl from '../shared/intl-hoc';

import { enum as permissions } from '../../../../../enums/admin-permissions';

const navigation = [
	{
		href: '/popups/main',
		name: 'Main',
		permission: null
	},
	{
		href: '/popups/images',
		name: 'Images',
		permission: null
	},
	{
		href: '/popups/campaigns',
		name: 'Campaigns',
		permission: null
	},
	{
		href: '/popups/custom-content',
		name: 'Custom content',
		permission: null
	}
];

export default Main => withPageContainer(withIntl(Main), {
	name: 'Popups',
	tabs: navigation,
	permission: permissions.popups
});


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/popups/wrap-main.js